export const ART_EVENT_STATUS = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
  FROZEN: 'FROZEN',
} as const;
